module.exports = __webpack_public_path__ + "static/media/NTUEworkshop-1128-00018.c0296e42.jpg";